<template>
    <div id="crowd-management" class="container pt-5">
        <div class="row mb-3">
            <div class="col-md-12">
                <h2 class="name">Crowd Management</h2>
                <h3 class="title text-muted">Veiligheid bij (publieks)evenementen</h3>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6">
                <h4>Wat is een crowd?</h4>
                <p>
                    Bij een crowd kunnen we spreken van een mensenmassa of menigte, waarbij aan een aantal randvoorwaarden wordt voldaan:
                    
                    <ul class="pt-3">
                        <li>een (relatief) groot aantal mensen per m2;</li>
                        <li>een bijeenkomst op een specifieke locatie;</li>
                        <li>voor een beperkte tijd, periode;</li>
                        <li>met een gemeenschappelijk doel;</li>
                        <li>en dat gemeenschappelijk gedrag vertoont.</li>
                    </ul>
                </p>
            </div>
            <div class="col-md-6 text-center">
                <font-awesome-icon icon="users" size="8x" class="primary"></font-awesome-icon>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-12">
                <h4>Crowd Management</h4>
                <p>Bij crowd management gaat het om systematisch analyseren en door gerichte maatregelen het reduceren van risico's die ontstaan wanneer zich een grote groep mensen ergens verzamelen.</p>
                <p>
                    Daarbij dient rekening gehouden te worden met verschillende facetten als:
                    <ul class="pt-3">
                        <li>De organisatie;</li>
                        <li>De locatie;</li>
                        <li>Menselijk gedrag (sociologie & massa-psychologie);</li>
                        <li>De dynamiek van het publiek;</li>
                        <li>Wetgeving.</li>
                    </ul>
                </p>
                <p>
                    Om dit goed in kaart te brengen worden er verschillende plannen opgesteld, zoals:
                    <ul class="pt-3">
                        <li>Risicoanalyse;</li>
                        <li>Calamiteitenplan;</li>
                        <li>Evacuatieplan / Ontruimingsplan;</li>
                        <li>Wetgeving.</li>
                    </ul>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Card from '@/components/Card'

export default {
    components: {
        Card
    }
}
</script>

<style scoped lang="scss">
.name,
.title {
    text-transform: uppercase;
}

.max-width {
    max-width: 350px;
}
</style>